var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ServiceBase } from "@/modules/services/models/ServiceBase";
import axios from 'axios';
import { Config } from "../models/Config";
var ConfigServices = (function (_super) {
    __extends(ConfigServices, _super);
    function ConfigServices() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ConfigServices.prototype.getConfig = function () {
        return new Promise(function (resolve, reject) {
            axios.get(process.env.VUE_APP_CONFIG_URL).then(function (response) {
                var config = new Config();
                config.setData(response.data);
                resolve(config);
            }).catch(function (error) {
                reject(error);
            });
        });
    };
    return ConfigServices;
}(ServiceBase));
export { ConfigServices };
export var configServices = new ConfigServices();



//////////////////
// WEBPACK FOOTER
// ./src/modules/config/services/ConfigServices.ts
// module id = ndE4
// module chunks = 10